export const mapIconUrlToGCP = (oldUrl) => {
  // Define the old and new base URLs
  const oldBaseUrl =
    "https://magicform-customer-widget-icons.s3.us-west-2.amazonaws.com/";
  const newBaseUrl = "https://storage.googleapis.com/customer-icons/";

  // Check if the old URL starts with the expected base
  if (oldUrl.startsWith(oldBaseUrl)) {
    // Construct the new URL
    return newBaseUrl + oldUrl.split("/").pop();
  }
  // newBase or custom URL is being used by customer
  return oldUrl;
};
